<template>
	<div>
		<!-- Headline -->
		<div slot="headline" class="fs5 lh125 fw7 c1 mb2">
			{{ $t("exclusions") }}
		</div>
		<j-card class="bg5">
			<j-list :list="computedList" v-if="computedList.length > 0">
				<div class="flex xs-12 p3" slot="list" slot-scope="{ item }">
					<div class="flex wrap xs-10 xs-left xs-middle fw7 lh125">
						<div class="xs-12 lh125 c1">{{ item.label }}</div>
						<div class="xs-12 fw4 c1 lh125">{{ item.remark }}</div>
					</div>
				</div>
			</j-list>
			<!-- Empty -->
			<div class="xs-12 p4 ta2 fs3 c6" v-if="computedList.length === 0">
				{{ $t("errors.no_data") }}
			</div>
		</j-card>
	</div>
</template>

<script>
import JCard from "@/components/JCard"
import JList from "@/components/JList"
import JButton from "@/components/JButton"
import dayjs from "dayjs"
import get from "lodash.get"
import api from "../api/"

export default {
	components: {
		JCard,
		JList,
		JButton
	},

	props: {
		policyId: {
			type: String,
			required: true,
			default: ""
		},

		offerId: {
			required: false,
			default: null
		},

		/**
		 * List of exclusions
		 * {
					id: null,
					codeName: {
						code: null,
						name: null
					},
					remark: null
				}
		 */
		list: {
			type: Array,
			required: false,
			default: () => []
		}
	},

	computed: {
		computedList() {
			return this.list.map(item => ({
				id: item.id,
				label: `${get(item, "codeName.code")} - ${get(item, "codeName.name")}`,
				remark: item.remark
			}))
		}
	}
}
</script>
